import { Box, Grid, List, ListItem, Typography } from '@mui/material';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { Toast } from 'primereact/toast';
import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import getRequest, { postRequest, putRequest } from '../../../assets/helper/ApiHandler';
import { regexPatterns } from '../../../assets/helper/RegexPattern';

var supplyPartnerObject = {
    supplyPartnerName: null,
    domain: null,
    contactName: null,
    contactEmail: null,
    supplyPartnerDiscription: null,
    publicNameForSupplyPartner: null,
    sellerType: null,
    isConfidential: false,
    impressionTrackingMethod: null
}

var formTouchedObj = {
    supplyPartnerName: false,
    domain: false,
    sellerType: false,
    isConfidential: false
}

const values = [
    { id: 1, text: "Basic Information", path: "basic-information" },
    { id: 2, text: "Description", path: "description" },
    { id: 3, text: "Sellers.json", path: "sellers.json" },
    { id: 4, text: "Preferences", path: "preferences" },
];


export function SupplyPartner() {
    const [supplyPartner, setSupplyPartner] = useState(supplyPartnerObject);
    const [supplyPartnerFormError, setSupplyPartnerFormError] = useState(supplyPartnerObject)
    const [active, setActive] = useState();
    const [formTouched, setFormTouched] = useState(formTouchedObj);
    const params = useParams();
    const navigate = useNavigate();
    const toast = useRef(null);
    const formMode = params.id ? 'Edit' : "Create";
    const isEditMode = params.id ? true : false;

    useEffect(() => {
        if (params.id) {
            getSupplyPartner();
        }
    }, [params.id]);


    useEffect(() => {
        if (Object.values(formTouched).some((touched) => touched === true)) {
            console.log(formTouched);
            validateFormData();
        }
    }, [supplyPartner, formTouched]);

    const handleInputChange = (e) => {
        let { id, value } = e.target;
        setSupplyPartner({
            ...supplyPartner,
            [id]: value
        });
        setFormTouched({
            ...formTouched,
            [id]: true,
        });
    };


    const getSupplyPartner = async () => {
        try {
            const dpdata = await getRequest(`/supply-partners/${params.id}`);
            setSupplyPartner(dpdata);
        } catch (error) {
            if(toast.current){
                toast.current.show({ severity: "error", summary: 'Error', detail: error });
            }
        }
    };

    const handleCancel = () => {
        navigate('/supply-partner');
    };

    const handleOnSubmit = () => {
        if (validateFormData()) {
            const payload = {
                ...supplyPartner,
                sellerType: supplyPartner.sellerType.toUpperCase()
            };
            if (isEditMode) {
                updateSupplyPartner(payload);
            } else {
                saveSupplyPartner(payload);
            }
        } else {
            if(toast.current){
                toast.current.show({ severity: "error", summary: 'Error', detail: "Check all required field " });
            }
        }
    };

    //.........Save and update API method......................
    const saveSupplyPartner = async (payload) => {
        try {
            let res = await postRequest('/supply-partners', payload, navigate);
                if(toast.current){
                    toast.current.show({ severity: "success", summary: 'Success', detail: "Supply partner Created! " });
                }
                setTimeout(() => { navigate('/supply-partner') }, 1000);
        } catch (error) {
            if(toast.current){
                toast.current.show({ severity: "error", summary: 'Error', detail: error });
            }
        }
    }

    const updateSupplyPartner = async (payload) => {
        try {
            let res = await putRequest(`/supply-partners/${params.id}`, payload, navigate);
                if(toast.current){
                    toast.current.show({ severity: "success", summary: 'Success', detail: "Supply partner updated! " });
                }
                setTimeout(() => { navigate('/supply-partner') }, 1000);
        } catch (error) {
            if(toast.current){
                toast.current.show({ severity: "error", summary: 'Error', detail: error });
            }
        }
    }


    const validateFormData = () => {
        let errors = {};
        let flag = false;

        if (!supplyPartner.supplyPartnerName) {
            errors.supplyPartnerName = 'SupplyPartner name is required!';
        }
        if (!supplyPartner.domain) {
            errors.domain = 'Domain is required!';
        }

        if (!supplyPartner.sellerType) {
            errors.sellerType = 'Seller Type is required!';
        }
        if (!supplyPartner.publicNameForSupplyPartner) {
            errors.publicNameForSupplyPartner = 'Public name for SupplyPartner is required!';
        }
        if (formTouched.isConfidential && !supplyPartner.isConfidential) { // Check isConfidential only if touched
            errors.isConfidential = 'Confidential is required!';
        }
        if (!supplyPartner.impressionTrackingMethod){
            errors.impressionTrackingMethod = 'Impression tracking method is required!';
         }
        if (supplyPartner.contactEmail) {

            if (!regexPatterns.email.test(supplyPartner.contactEmail)) {
                errors.contactEmail = 'Email address required!. E.g. example@email.com';
            }
        }

        setSupplyPartnerFormError(errors);
        if (Object.keys(errors).length === 0) {
            flag = true;
        }
        return flag;
    };

    let { supplyPartnerName, domain, contactName, contactEmail, supplyPartnerDiscription, publicNameForSupplyPartner, sellerType, impressionTrackingMethod } = supplyPartner

    return (
        <div>
            <Toast ref={toast} position="bottom-right"></Toast>
            <Box className='main-content-header header-bottom-line'>
                <h2>{formMode + " Supply Partner"}</h2>
            </Box>
            <Box>
                <Grid container spacing={2}>
                    <Grid item xs={3}>
                        <Box className='content-sticky-top'>
                            <List className='list-page-link'>
                                {values.map((val) => (
                                    <ListItem key={val.id} className='fs-2' onClick={() => setActive(val.id)}>
                                        <a href={'#' + val.path} style={{ textDecoration: 'none' }} className={active === val.id ? "active" : ""}>{val.text}</a>
                                    </ListItem>
                                ))}
                            </List>
                        </Box>
                    </Grid>
                    <Grid item xs={9} sx={{ gap: 1, flexGrow: 1, overflow: 'hidden auto', scrollBehavior:"smooth" }} >
                        <Box className="card omega-forms">
                            <Box id="basic-information" className="basic-information-new" sx={{ minWidth: 0, flex: 1, padding: '1rem' }}>
                                <Box sx={{ minWidth: 0, flex: 1 }}>
                                    <Typography level="title-sm" className='fs-1'>Basic Information</Typography>
                                </Box>
                                <Grid container spacing={2}>
                                    <Grid item xs={4}>
                                        <Typography level="title-sm" className='fs-2'>Supply Partner Name *</Typography>
                                        <Typography level="body-xs" className='fs-3' htmlFor="supply-partner-name">Enter the name of the supply partner</Typography>
                                    </Grid>
                                    <Grid item xs={8}>
                                        <InputText
                                            id="supplyPartnerName"
                                            className={supplyPartnerFormError.supplyPartnerName ? 'mr-2 p-invalid' : 'mr-2'}
                                            value={supplyPartnerName ? supplyPartnerName : ''}
                                            onChange={handleInputChange}
                                        />
                                        {supplyPartnerFormError.supplyPartnerName && (
                                            <Typography level="title-sm" className="error-message fs-2">{supplyPartnerFormError.supplyPartnerName}</Typography>
                                        )}
                                    </Grid>
                                </Grid>
                                <Grid container spacing={2}>
                                    <Grid item xs={4}>
                                        <Typography level="title-sm" className='fs-2'>Domain *</Typography>
                                        <Typography level="body-xs" className='fs-3'>Enter the name of the domain</Typography>
                                    </Grid>
                                    <Grid item xs={8}>
                                        <InputText id="domain"
                                            placeholder=""
                                            className={supplyPartnerFormError.domain ? 'mr-2 p-invalid' : 'mr-2'}
                                            value={domain ? domain : ''}
                                            onChange={handleInputChange}
                                        />
                                        {supplyPartnerFormError.domain && (
                                            <Typography level="title-sm" className="error-message fs-2">{supplyPartnerFormError.domain}</Typography>
                                        )}
                                    </Grid>
                                </Grid>
                                <Grid container spacing={2}>
                                    <Grid item xs={4}>
                                        <Typography level="title-sm" className='fs-2'>Contact Name</Typography>
                                        <Typography level="body-xs" className='fs-3'>Enter the name of the contact name</Typography>
                                    </Grid>
                                    <Grid item xs={8}>
                                        <InputText id="contactName"
                                            placeholder=""
                                            className="mr-2 flex-1"
                                            value={contactName ? contactName : ''}
                                            onChange={handleInputChange}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container spacing={2}>
                                    <Grid item xs={4}>
                                        <Typography level="title-sm" className='fs-2'>Contact Email</Typography>
                                        <Typography level="body-xs" className='fs-3'>Enter the name of the contact email </Typography>
                                    </Grid>
                                    <Grid item xs={8}>
                                        <InputText id="contactEmail"
                                            placeholder=""
                                            className="mr-2"
                                            value={contactEmail ? contactEmail : ''}
                                            onChange={handleInputChange}
                                        />
                                        {supplyPartnerFormError.contactEmail && (
                                            <Typography level="title-sm" className="error-message fs-2">{supplyPartnerFormError.contactEmail}</Typography>
                                        )}
                                    </Grid>
                                </Grid>
                            </Box>
                            <Box sx={{ minWidth: 0, flex: 1, padding: '1rem' }} className="form-group-border-top form-group-border-bottom">
                                <Box id="description" sx={{ minWidth: 0, flex: 1 }}>
                                    <Typography level="title-sm" className='fs-1'>Description</Typography>
                                </Box>
                                <Grid container spacing={2}>
                                    <Grid item xs={4}>
                                        <Typography level="title-sm" className='fs-2'>Supply Partner Description</Typography>
                                        <Typography level="body-xs" className='fs-3' htmlFor="supply-partner-name">Enter a description for supply partner description</Typography>
                                    </Grid>
                                    <Grid item xs={8}>
                                        <InputText id="supplyPartnerDiscription"
                                            placeholder=""
                                            className="mr-2"
                                            value={supplyPartnerDiscription ? supplyPartnerDiscription : ''}
                                            onChange={handleInputChange}
                                        />
                                    </Grid>
                                </Grid>
                            </Box>
                            <Box sx={{ minWidth: 0, flex: 1, padding: '1rem' }} className="form-group-border-bottom">
                                <Box id="sellers.json" sx={{ minWidth: 0, flex: 1 }}>
                                    <Typography level="title-sm" className='fs-1'>Sellers.json</Typography>
                                </Box>
                                <Grid container spacing={2}>
                                    <Grid item xs={4}>
                                        <Typography level="title-sm" className='fs-2'>Public Name for Supply Partner *</Typography>
                                        <Typography level="body-xs" className='fs-3' htmlFor="supply-partner-name">Enter the name of the  public name for supply partner</Typography>
                                    </Grid>
                                    <Grid item xs={8}>
                                        <InputText id="publicNameForSupplyPartner"
                                            placeholder=""
                                            className={supplyPartnerFormError.publicNameForSupplyPartner ? 'mr-2 p-invalid' : 'mr-2'}
                                            value={publicNameForSupplyPartner ? publicNameForSupplyPartner : ''}
                                            onChange={handleInputChange}
                                        />
                                        {supplyPartnerFormError.publicNameForSupplyPartner && (
                                            <Typography level="title-sm" className="error-message fs-2">{supplyPartnerFormError.publicNameForSupplyPartner}</Typography>
                                        )}
                                    </Grid>
                                </Grid>
                                <Grid container spacing={2}>
                                    <Grid item xs={4}>
                                        <Typography level="title-sm" className='fs-2'>Seller Type *</Typography>
                                        <Typography level="body-xs" className='fs-3' htmlFor="supply-partner-name">Enter the name of the seller type</Typography>
                                    </Grid>
                                    <Grid item xs={8}>
                                        <Dropdown
                                            id="sellerType"
                                            className={
                                                supplyPartnerFormError.sellerType
                                                    ? "mr-2 p-invalid"
                                                    : "mr-2"
                                            } value={sellerType ? sellerType : ''}
                                            onChange={handleInputChange}
                                            options={[
                                                { label: 'Publisher', value: 'PUBLISHER' },
                                                { label: 'Intermediary', value: 'INTERMEDIARY' },
                                                { label: 'Both', value: 'BOTH' }
                                            ]}
                                        />
                                        {supplyPartnerFormError.sellerType && (
                                            <Typography level="title-sm" className="error-message fs-2">
                                                {supplyPartnerFormError.sellerType}
                                            </Typography>
                                        )}
                                    </Grid>
                                </Grid>
                                <Grid container spacing={2}>
                                    <Grid item xs={4}>
                                        <Typography level="title-sm" className='fs-2'>Is Confidential?</Typography>
                                        <Typography level="body-xs" className='fs-3' htmlFor="supply-partner-name">select is confidential ?</Typography>
                                    </Grid>
                                    <Grid item xs={8}>
                                        <Dropdown
                                            value={supplyPartner ? supplyPartner.isConfidential : false}
                                            onChange={(e) => setSupplyPartner({ ...supplyPartner, isConfidential: e.value === true })}
                                            options={[
                                                { name: 'Yes', value: true },
                                                { name: 'No', value: false }
                                            ]}
                                            optionLabel="name" >
                                            /</Dropdown>
                                        {supplyPartnerFormError.isConfidential && (
                                            <Typography level="title-sm" className="error-message fs-2">{supplyPartnerFormError.isConfidential}</Typography>
                                        )}
                                    </Grid>
                                </Grid>
                            </Box>
                            <Box sx={{ minWidth: 0, flex: 1, padding: '1rem' }} className="form-group-border-bottom">
                                <Box id="preferences" sx={{ minWidth: 0, flex: 1 }}>
                                    <Typography level="title-sm" className='fs-1'>Preferences</Typography>
                                </Box>
                                <Grid container spacing={2}>
                                    <Grid item xs={4}>
                                        <Typography level="title-sm" className='fs-2'>Impression Tracking Method *</Typography>
                                        <Typography level="body-xs" className='fs-3' htmlFor="supply-partner-name">Select impression tracking method </Typography>
                                    </Grid>
                                    <Grid item xs={8}>
                                        <Dropdown
                                            id="impressionTrackingMethod "
                                            placeholder=""
                                            className={supplyPartnerFormError.impressionTrackingMethod ? 'mr-2 p-invalid' : 'mr-2'}
                                            value={supplyPartner.impressionTrackingMethod}
                                            onChange={(e) => setSupplyPartner({ ...supplyPartner, impressionTrackingMethod: e.value })}
                                            options={[
                                                { name: 'BURL', value: 'BURL' },
                                                { name: 'ADM', value: 'ADM' }
                                            ]}
                                            optionLabel="name" />
                                            <Typography level="title-sm" className="error-message fs-2">{supplyPartnerFormError.impressionTrackingMethod}</Typography>
                                    </Grid>
                                </Grid>
                            </Box>
                            <Box sx={{ minWidth: 0, display: 'flex', padding: '1rem', justifyContent: 'end' }} gap={2} className="form-footer">
                                <Button type="button" className="button-style-2" label="Cancel" size="small" onClick={handleCancel}></Button>
                                <Button type="button" className="button-style-1" label="Save" size="small" onClick={handleOnSubmit}></Button>
                            </Box>
                        </Box>
                    </Grid>
                </Grid>
            </Box>
        </div >
    );
};

export default SupplyPartner;